$( document ).ready(function() {

    initFilterByUrl();

    $( ".show_hidden_image" ).hover(
        function() {
            var product_id = $(this).data('product-id');
            $(this).hide();
            $('#hidden_image_' + product_id).show();
        }
    );
    $( ".show_default_image" ).hover(
        function() {

        },
        function() {
            var product_id = $(this).data('product-id');
            $(this).hide();
            $('#default_image_' + product_id).show();
        }
    );

    $('.filter-by-collection').on('click', function (){
        $('.chosen-filter__items').empty();
        var filter_list = '';
        var filter_occasion_list_array = '';
        var filter_silhouette_list_array = '';
        var filter_size_list_array = '';
        var filter_list_array_hash = '';
        var i = 0;
        $( ".filter-by-collection" ).each(function( index ) {
            if($(this).is(":checked")){

                if($(this).hasClass('filter-occasion')) {
                    if (filter_occasion_list_array != '') {
                        filter_occasion_list_array += ",\"" + $(this).attr('data-attr-collection-handle') + "\"";
                    } else {
                        filter_occasion_list_array = "\"" + $(this).attr('data-attr-collection-handle') + "\"";
                    }
                    if(filter_list_array_hash != ''){
                        filter_list_array_hash += "," + $(this).attr('data-attr-collection-handle') + "";
                    }else{
                        filter_list_array_hash = $(this).attr('data-attr-collection-handle');
                    }
                }
                if($(this).hasClass('filter-silhouette')) {
                    if (filter_silhouette_list_array != '') {
                        filter_silhouette_list_array += ",\"" + $(this).attr('data-attr-collection-handle') + "\"";
                    } else {
                        filter_silhouette_list_array = "\"" + $(this).attr('data-attr-collection-handle') + "\"";
                    }
                    if(filter_list_array_hash != ''){
                        filter_list_array_hash += "," + $(this).attr('data-attr-collection-handle') + "";
                    }else{
                        filter_list_array_hash = $(this).attr('data-attr-collection-handle');
                    }
                }
                if($(this).hasClass('filter-size')) {
                    if (filter_size_list_array != '') {
                        filter_size_list_array += ",\"" + $(this).attr('data-attr-collection-handle') + "\"";
                    } else {
                        filter_size_list_array = "\"" + $(this).attr('data-attr-collection-handle') + "\"";
                    }
                    if(filter_list_array_hash != ''){
                        filter_list_array_hash += "," + $(this).attr('data-attr-collection-handle') + "";
                    }else{
                        filter_list_array_hash = $(this).attr('data-attr-collection-handle');
                    }
                }


                filter_list +=  '<div class="chosen-filter__item">' +
                    '<span>' + $(this).attr('data-attr-collection-title') + '</span> ' +
                    '<button class="close-btn" onclick="uncheckFilter(\'' + $(this).attr('data-attr-collection-handle') + '\')"></button> ' +
                    '</div>';
                i++;
            }
        });

        if(i>0){
            $('.chosen-filter__items').html(filter_list);
            $('.chosen-filter').show();
        }else{
            $('.chosen-filter').hide();
        }

        addHashToCollectionUrl(filter_list_array_hash);

        var arrayFiltersOccasion   = JSON.parse("[" + filter_occasion_list_array + "]");
        var arrayFiltersSilhouette = JSON.parse("[" + filter_silhouette_list_array + "]");
        var arrayFiltersSize       = JSON.parse("[" + filter_size_list_array + "]");


        if(arrayFiltersOccasion.length>0 || arrayFiltersSilhouette.length>0 || arrayFiltersSize.length>0 ) {

            $('.size-filter-element, .collection-filter-element').hide();

            $(".product-list__item").each(function (index) {
                var product_collections = $(this).attr('data-attr-collections');
                var array_product_collections = JSON.parse("[" + product_collections + "]");

                var product_sizes = $(this).attr('data-attr-sizes');
                var array_product_sizes = JSON.parse("[" + product_sizes + "]");

                var display_this_product = 0;

                if(arrayFiltersSize.length != 0 && arrayFiltersOccasion.length==0 && arrayFiltersSilhouette.length==0) {
                    arrayFiltersSize.forEach(function (item, i, arr) {
                        if (array_product_sizes.includes(item.toString())) {
                            display_this_product = 1;
                        }
                    });
                }else {

                    if (arrayFiltersOccasion.length > 0 && arrayFiltersSilhouette.length == 0) {
                        arrayFiltersOccasion.forEach(function (item, i, arr) {
                            if (array_product_collections.includes(item)) {

                                if(arrayFiltersSize.length != 0) {
                                    arrayFiltersSize.forEach(function (item, i, arr) {
                                        if (array_product_sizes.includes(item.toString())) {
                                            display_this_product = 1;
                                        }
                                    });
                                }else {
                                    display_this_product = 1;
                                }
                            }
                        });
                    } else if (arrayFiltersOccasion.length == 0 && arrayFiltersSilhouette.length > 0) {
                        arrayFiltersSilhouette.forEach(function (item, i, arr) {
                            if (array_product_collections.includes(item)) {
                                if(arrayFiltersSize.length != 0) {
                                    arrayFiltersSize.forEach(function (item, i, arr) {
                                        if (array_product_sizes.includes(item.toString())) {
                                            display_this_product = 1;
                                        }
                                    });
                                }else {
                                    display_this_product = 1;
                                }
                            }
                        });
                    } else if (arrayFiltersOccasion.length > 0 && arrayFiltersSilhouette.length > 0) {
                        var display_this_product_1 = 0;
                        var display_this_product_2 = 0;

                        arrayFiltersOccasion.forEach(function (item, i, arr) {
                            if (array_product_collections.includes(item)) {
                                display_this_product_1 = 1;
                            }
                        });

                        arrayFiltersSilhouette.forEach(function (item, i, arr) {
                            if (array_product_collections.includes(item)) {
                                display_this_product_2 = 1;
                            }
                        });

                        if (display_this_product_1 > 0 && display_this_product_2 > 0) {
                            display_this_product = 1;
                        }
                    }
                }



                if (display_this_product != 1) {
                    $(this).hide();
                } else {
                    $(this).show();
                    $(".filter-size").each(function (index) {
                        var element_size = $(this).data('attr-collection-title');
                        if (array_product_sizes.includes(element_size.toString())) {
                            $(this).parent().show();
                        }
                    });

                    $(".filter-element-collection").each(function (index) {
                        var element_collection = $(this).data('attr-collection-handle');
                        console.log(array_product_collections);
                        console.log(element_collection);

                        if (array_product_collections.includes(element_collection.toString())) {
                            $(this).parent().show();
                        }
                    });
                }
            });
        }else{
            $(".product-list__item, .size-filter-element, .collection-filter-element").show();
        }

    });

    $('.chosen-filter__clear').on('click', function (){
        $( ".filter-by-collection" ).each(function( index ) {
            if($(this).is(":checked")){
                $(this).click();
            }
        });
    });

});

function addHashToCollectionUrl(filter_list_array_hash){
    var url_ob = new URL(document.URL);
    if(filter_list_array_hash!='') {
        url_ob.hash = '#filters=' + filter_list_array_hash;
    }else{
        //url_ob.hash = '#';
        window.location.href.substr(0, window.location.href.indexOf('#'))
    }
    var new_url = url_ob.href;
    document.location.href = new_url
}
function initFilterByUrl() {
    var hash = new URL(document.URL).hash;
    var res = getHashParams();
    var filters_list = res.filters;
    if(typeof filters_list !== 'undefined') {
        var arrayFilters = filters_list.split(',');
        setTimeout(function () {
                $(".filter-by-collection").each(function (index) {
                    var item = $(this).data('attr-collection-handle');
                    if (arrayFilters.includes(item)) {
                        $(this).click();
                    }
                });
            },
            1000);
    }
}
function getHashParams() {

    var hashParams = {};
    var e,
        a = /\+/g,  // Regex for replacing addition symbol with a space
        r = /([^&;=]+)=?([^&;]*)/g,
        d = function (s) { return decodeURIComponent(s.replace(a, " ")); },
        q = window.location.hash.substring(1);

    while (e = r.exec(q))
        hashParams[d(e[1])] = d(e[2]);

    return hashParams;
}
function uncheckFilter(collection) {
    if($('#filter_' + collection).is(":checked")) {
        $('#filter_' + collection).click();
    }
}

